// extracted by mini-css-extract-plugin
export default {"container":"Location__container___oDali"};